import { ReactComponent as Tennis } from "../../static/images/tennis.svg";
import { ReactComponent as Boxing } from "../../static/images/boxing.svg";
import { ReactComponent as Yoga } from "../../static/images/yoga.svg";
import { ReactComponent as Soccer } from "../../static/images/soccer.svg";
import { ReactComponent as Basketball } from "../../static/images/basketball.svg";
import { ReactComponent as Dance } from "../../static/images/dance.svg";
import { ReactComponent as PersonalTrainer } from "../../static/images/presonal_trainer.svg";
import { ReactComponent as Other } from "../../static/images/consumer_other.svg";

import { ReactComponent as MMA } from "../../static/images/mma.svg";
import { ReactComponent as Padel } from "../../static/images/padel.svg";
import { ReactComponent as Pickleball } from "../../static/images/pickleball.svg";
import { ReactComponent as AmericanBall } from "../../static/images/american_ball.svg";
import { ReactComponent as Judo } from "../../static/images/judo.svg";
import { ReactComponent as Golf } from "../../static/images/golf.svg";
import { ReactComponent as Baseball } from "../../static/images/baseball.svg";
import { ReactComponent as Karate } from "../../static/images/karate.svg";
import { ReactComponent as Ballet } from "../../static/images/ballet.svg";
import { ReactComponent as HipHop } from "../../static/images/hip_hop.svg";
import { ReactComponent as Gymnastics } from "../../static/images/gymnastics.svg";
import { ReactComponent as Fitness } from "../../static/images/fitness.svg";

import { ReactComponent as Mathematics } from "../../static/images/math.svg";
import { ReactComponent as English } from "../../static/images/english_lesson.svg";
import { ReactComponent as Biology } from "../../static/images/biology.svg";
import { ReactComponent as Chemistry } from "../../static/images/chemistry.svg";
import { ReactComponent as Phisics } from "../../static/images/phisics.svg";
import { ReactComponent as History } from "../../static/images/history.svg";
import { ReactComponent as Geography } from "../../static/images/geography.svg";
import { ReactComponent as Coding } from "../../static/images/coding.svg";
import { ReactComponent as ForeignLanguage } from "../../static/images/foreign_language.svg";
import { ReactComponent as Literature } from "../../static/images/literature.svg";
import { ReactComponent as Psychology } from "../../static/images/psychology.svg";

import { ReactComponent as DanceMusic } from "../../static/images/categories/dance_music.svg";
import { ReactComponent as Education } from "../../static/images/categories/education.svg";
import { ReactComponent as HealthFitness } from "../../static/images/categories/health_fitness.svg";
import { ReactComponent as MartialArts } from "../../static/images/categories/martial_arts.svg";
import { ReactComponent as Sports } from "../../static/images/categories/sports.svg";

const RenderActivities = ({ activities }) => {
  const activityIcons = {
    tennis: <Tennis />,
    boxing: <Boxing />,
    yoga: <Yoga />,
    soccer: <Soccer />,
    basketball: <Basketball />,
    "personal trainer": <PersonalTrainer />,
    mma: <MMA />,
    padel: <Padel />,
    pickleball: <Pickleball />,
    "american football": <AmericanBall />,
    judo: <Judo />,
    baseball: <Baseball />,
    golf: <Golf />,
    karate: <Karate />,
    ballet: <Ballet />,
    "hip-hop": <HipHop />,
    "ballroom dance": <Dance />,
    gymnastics: <Gymnastics />,
    fitness: <Fitness />,

    math: <Mathematics />,
    "english language": <English />,
    biology: <Biology />,
    chemistry: <Chemistry />,
    physics: <Phisics />,
    history: <History />,
    geography: <Geography />,
    coding: <Coding />,
    "foreign languages": <ForeignLanguage />,
    literature: <Literature />,
    psychology: <Psychology />,

    // categories

    sport: <Sports />,
    education: <Education />,
    "health and fitness": <HealthFitness />,
    "martial arts": <MartialArts />,
    "dance and music": <DanceMusic />,
  };

  if (activities) {
    return <>{activityIcons[activities.toLowerCase()] || <Other />}</>;
  }
};

export default RenderActivities;
